module.exports = __webpack_public_path__ + "static/temp-slider-image-5c3bbbec30737b41f9966b3ed1af1153.jpg";